import styled from 'styled-components';

export const  Product = styled.div`
    background-color: ${({theme}) => theme.color.white};
    border: 1px solid ${({theme}) => theme.color.light};
    border-radius: 3px;
    margin: ${props => props.margin+"px"};
    /* min-height: 265px; */
    
    a {
        display: block;
        position: relative;
        -webkit-box-shadow: 0 6px 8px 0 rgba(110,110,110,0.1);
        box-shadow: 0 6px 8px 0 rgba(110,110,110,0.1);
    }
`;

export const Discount = styled.div`
    height: 40px;
    width: 40px;
    border-radius: 100px;
    border: 0.0938rem dashed ${({theme}) => theme.color.blue};
    background-color: ${({theme}) => theme.color.red};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 5px;
    right: 5px;
`;

const DiscountExtends = styled.div`
    line-height: 1;
    color: ${({theme}) => theme.color.white};
    font-size: 0.75rem;
    font-weight: ${({theme}) => theme.fontWeight.fw700};

`;

export const DiscountValue = styled(DiscountExtends)`

`;

export const OffText = styled(DiscountExtends)`
    text-transform: uppercase;
    font-size: 0.4375rem;
`;

export const  WrapperProductImage = styled.div`
    /* overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center; */
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    & > .WrapAnchorPicture {
            height: 100vh;
            max-height: 9.875rem;

            & > .AnchorPicture {
                display: block;
                height: 100%;
                width: 100%;
                overflow: hidden;

                & > .WrapPicture {
                    height: 100%;
                    width: 100%;
                    picture {
                        source,
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border: 0;
                            max-width: 100%;
                            display: inline-block;
                            vertical-align: middle;
                        }
                    }
                }
            }
        }
`;

export const  Content = styled.div`
    padding: 0.625rem;
    padding-bottom: 1.25rem;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
`;

export const  Wrapp = styled.div`
    /* flex: 1; */
`;

export const  Title = styled.div`
    font-size: 0.875rem;
    color: ${({theme}) => theme.color.grayBold};
    font-weight: 600;
    line-height: 1;
    word-break: break-word;
    margin-bottom: .5rem;
`;

export const  Brand = styled(Title)`
    color: ${({theme}) => theme.color.gray};
    margin: .3125rem 0 .625rem 0;
    flex: 1;
    min-height: auto;
`;

export const  Price = styled(Title)`
    min-height: auto;
    font-size: 0.875rem;
    color: ${props => props.priceColor};
    /* white-space: nowrap; */
`;

const announcedByType = {
    atacadao: "#FF5A00",
    carrefour: "#1E5BC6",
};

export const AnnouncedBy = styled.div`
    border-top: 1px solid ${props => props.company ? props.typePartner ? announcedByType[props.company] : 'transparent' : '#CCCCCC'};
    border-left: 1px solid ${props => props.company ? props.typePartner ? announcedByType[props.company] : 'transparent' : '#CCCCCC'};
    border-bottom: 1px solid ${props => props.company ? props.typePartner ? announcedByType[props.company] : announcedByType[props.company] : '#CCCCCC'};
    border-right: 1px solid ${props => props.company ? props.typePartner ? announcedByType[props.company] : announcedByType[props.company] : '#CCCCCC'};
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    display: table;
    background-color: ${props => props.company ? props.typePartner ? '#FFFFFF' : announcedByType[props.company] : '#CCCCCC'};
    color: ${props => props.typePartner ? announcedByType[props.company] : '#FFFFFF'};
    font-weight: 500;
    font-size: .75rem;
    padding: 2px 4px;
    position: absolute;
    top: 0;
    left: 0;
`;